export const raceTime = (trade: any): string =>
  trade.start_time || trade.selection_snapshot?.start_time || trade.legs?.[0]?.start_time || '';
export function raceTimeNewestFirst(a: any, b: any): number {
  const left = Date.parse(raceTime(a)), right = Date.parse(raceTime(b));
  if (!Number.isFinite(left)) return Number.isFinite(right) ? 1 : 0;
  if (!Number.isFinite(right)) return -1;
  return right - left;
}
// Display classification only. Does not enqueue, submit or alter an order.
export function submittedTrades(trades: any[], mode: string) {
  return trades.filter(t => t.mode === mode && (
    t.bet_id || t.execution?.bet_id || t.submitted_at ||
    ['ACCEPTED', 'SUBMITTED', 'MATCHED', 'SETTLED', 'REJECTED', 'UNKNOWN', 'LAPSED', 'PAPER_PENDING'].includes(t.state)
  )).sort(raceTimeNewestFirst);
}
